import messages from "@/plugins/i18n";
import type { Ref } from "vue";
import { defineComponent } from "vue";
import { showConfirmationDialog } from "@/components/composables/promptDialogs";

export const bmLeaveConfirmationLeavePage = async (
  showDialog: boolean,
  next: Function
) => {
  if (
    !showDialog ||
    (await showConfirmationDialog(
      messages.prompt_leave_title,
      messages.prompt_leave_text
    ))
  ) {
    next();
  }
};

export const BmLeaveConfirmation = defineComponent({
  methods: {
    leavePage: bmLeaveConfirmationLeavePage,
  },
});

export const useLeaveDialog = (
  showDialog: Ref<boolean>,
  leaveTitle: string = messages.prompt_leave_title,
  leaveText: string = messages.prompt_leave_text
) => {
  const checkUserCanLeave = async () => {
    if (
      !showDialog.value ||
      (await showConfirmationDialog(leaveTitle, leaveText))
    ) {
      return true;
    }
    return false;
  };

  return {
    checkUserCanLeave,
  };
};
